import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "../../../hook/use-search-params";
import { StatisticsEmployeeService } from "../../../services/department-viags/statistics-employee.service";
import { useMemo } from "react";
import moment from "moment";
import { isDateInRange } from "../../../helper/dateTimeHelper";

export const useDocByDepartment = () => {
  const { searchParams } = useSearchParams();
  const departmentCode = searchParams.get("deptCode") ?? "";
  const start = searchParams.get("start") ?? "";
  const end = searchParams.get("end") ?? "";

  const { data, isLoading } = useQuery({
    queryKey: ["docs-department", departmentCode],
    queryFn: () => StatisticsEmployeeService.getDocForDepartment(departmentCode),
  });
  const filteredData = useMemo(() => {
    if (!start || !end) return data;

    return data?.filter((e) => {
      const publishDay = moment(e.publishDay);
      return isDateInRange(publishDay, moment(start), moment(end));
    });
  }, [data, end, start]);


  // const countInternalDocument = 0;
  // const countExternalDocument = 1;

  const countInternalDocument = filteredData?.filter((e) => e.docType === "Nội bộ").length;
  const countExternalDocument = filteredData?.filter((e) => e.docType === "Bên ngoài").length;
  const countSQMSDocument = filteredData?.filter((e) => e.docType === "TÀI LIỆU SQMS").length;
  const countTotal = filteredData?.length;

  return { isLoading, filteredData, countInternalDocument, countExternalDocument, countSQMSDocument, countTotal };
};
